import { User } from '@/payload-types'

import { ImageForm } from './ImageForm'
import { LocationForm } from './LocationForm'
import { ProfileForm } from './ProfileForm'
import { ProfileSteps } from './ProfileStep'
import { SocialForm } from './SocialForm'

export const CurrentForm = ({
  currentProfileStep,
  user,
  setOpenDrawer,
  setCurrentProfileStep,
  onUserUpdated,
}: {
  currentProfileStep: ProfileSteps
  user: User
  setOpenDrawer: (open: boolean) => void
  setCurrentProfileStep: (step: ProfileSteps) => void
  onUserUpdated?: (updatedUser?: User) => Promise<void>
  // onUserUpdated?: () => void
}) => {
  switch (currentProfileStep) {
    case 'profile':
      return (
        <ProfileForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
          currentProfileStep={currentProfileStep}
        />
      )
    case 'location':
      return (
        <LocationForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
    case 'socials':
      return (
        <SocialForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
    case 'profileImage':
      return (
        <ImageForm
          user={user}
          setOpenDrawer={setOpenDrawer}
          setCurrentProfileStep={setCurrentProfileStep}
          onUserUpdated={onUserUpdated}
        />
      )
  }
}
